import { render, staticRenderFns } from "./DeleteModual.vue?vue&type=template&id=f813d476"
import script from "./DeleteModual.vue?vue&type=script&lang=js"
export * from "./DeleteModual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports